'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const tslib = require('tslib');
const useUnmountEffect = require('./use-unmount-effect.js');

function useForceUpdate() {
  var unloadingRef = React.useRef(false);
  var _a = tslib.__read(React.useState(0), 2),
    forcedRenderCount = _a[0],
    setForcedRenderCount = _a[1];
  useUnmountEffect.useUnmountEffect(function () {
    return unloadingRef.current = true;
  });
  return React.useCallback(function () {
    !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
  }, [forcedRenderCount]);
}

exports.useForceUpdate = useForceUpdate;
